'use client';

import { c as _c } from "react/compiler-runtime";
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import { RouterLink } from 'src/routes/components';
import { paths, newSearchParams } from 'src/routes/paths';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function AddProductButton(t0) {
  const $ = _c(15);
  let other;
  let ref;
  let sx;
  if ($[0] !== t0) {
    ({
      ref,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = ref;
    $[3] = sx;
  } else {
    other = $[1];
    ref = $[2];
    sx = $[3];
  }
  const {
    currentLang
  } = useTranslate();
  const t1 = `${paths.product.new}${newSearchParams({
    country: currentLang.countryName
  })}`;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: 48,
      height: 48,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== sx) {
    t3 = Array.isArray(sx) ? sx : [sx];
    $[5] = sx;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = [t2, ...t3];
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Fab size="small" color="inherit"><SvgIcon><path fill="currentColor" d="M18 13h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" /></SvgIcon></Fab>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== other || $[11] !== ref || $[12] !== t1 || $[13] !== t4) {
    t6 = <Box ref={ref} component={RouterLink} href={t1} sx={t4} {...other}>{t5}</Box>;
    $[10] = other;
    $[11] = ref;
    $[12] = t1;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}